import { AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import { apisiseci } from "../api";
import { AdminUser } from "../../@types/admin-user";

export function useAdminUserDetails() {
    const token = localStorage.getItem("gov_access_token_sso");

    return useQuery<AdminUser, AxiosError<{ detail: string }>>({
        retry: false,
        enabled: !!token,
        queryKey: ['admin-user', 'details', token],
        queryFn: async () => {
            const response = await apisiseci.get<Array<AdminUser>>(
                `/cms/user/`, { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data[0];
        },
    });
}
